<div class="p-4">
  <form [formGroup]="formGroup" (submit)="submit()">
    <p i18n>訊息資料夾名稱</p>

    <mat-form-field legacyAppearance class="w-full">
      <input matInput formControlName="name" />
    </mat-form-field>

    <div class="text-right">
      <button type="button" mat-button (click)="cancel()" i18n>取消</button>
      <button
        mat-raised-button
        type="submit"
        color="primary"
        [disabled]="formGroup.invalid"
        i18n
      >
        確定
      </button>
    </div>
  </form>
</div>
